export enum ModuleCode {
  DASHBOARD = 'DB',
  USER_MANAGEMENT = 'UM',
  TRAINEE_APPROVAL = 'TA',
  TRAINEE_MANAGEMENT = 'TM',
  ATTENDANCE_MANAGEMENT = 'AM',
  MODULE_CATEGORY = 'MC',
  MODULES_AND_SESSION = 'MS',
  TRAINING_MANAGEMENT = 'TGM',
  ROUTINE_MANAGEMENT = 'RM',
  ORGANIZATION = 'ORG',
  ORGANIZATION_DEPARTMENT = 'OD',
  ORGANIZATION_CENTER = 'OC',
  HALL_MANAGEMENT = 'HM',
  ROLES_AND_PERMISSIONS = 'RP',
  FEEDBACK_MANAGEMENT = 'FM',
  CERTIFICATE_TEMPLATE = 'CT',
  RESOURCE_PERSON = 'RPP',
  TRAINEE_REQUEST = 'TR',

  // new
  ATTENDANCE_REQUEST = 'ARQ',
  EVALUATION = 'EVL',
  MASTER_DATA = 'MD',
  PRE_POST_EVALUATION = 'PPE',
  GALLERY = 'GL',
  ASSIGNMENT_MANAGEMENT = 'ASSM',
  SERVICE_GROUP = 'SG',
  SERVICE_GROUP_MANAGEMENT = 'SGM',
  SERVICE_SUB_GROUP = 'SSG',
  SERVICE_SUB_GROUP_MANAGEMENT = 'SSGM',
  ETHNICITY = 'EN',
  ASSIGN_ROLE = 'AR',
  RESOURCES = 'RS',
  APP_CONFIGURATION = 'AP'
}
